import ISelectInputModel from '../../../../../common/components/load-filters/load-filter-advanced/components/location-filter/interfaces/ISelectInputModel';
import ILoadMaterialResponse from '../../../../../common/components/load-filters/interfaces/ILoadMaterialResponse';
import ILoadsLocationResponse from '../../../../../common/components/load-filters/interfaces/ILoadsLocationResponse';
import i18n from '../../../../../lib/i18n';
import OfferStatusFilter from '../../enums/offer-status-filter.enum';
import { getLabelDescription } from '../../../../../utils/string-utils';
import { IRoundState } from '../../../../../app/reducers/round/round-reducer';

export function getOfferStatusByRoundPhase(roundState: IRoundState) {
    const options: any[] = [];

    const enumStrings = Object.keys(OfferStatusFilter).filter(enumKey => {
        if (roundState.currentPhase === 'Acceptance') {
            return (
                Number.isNaN(Number(enumKey)) &&
                (enumKey === 'WaitingAcceptance' || enumKey === 'Accepted')
            );
        }

        if (roundState.currentPhase === 'Confirmation') {
            return (
                Number.isNaN(Number(enumKey)) &&
                (enumKey === 'WaitingConfirmation' || enumKey === 'Confirmed')
            );
        }

        return false;
    });

    enumStrings.forEach((enumKey: string) => {
        const label = i18n.t(`SmartCargas.Rounds.${enumKey}`);

        options.push({
            value: enumKey,
            label,
        });
    });

    return options;
}

export const mapDescriptionToSelectInputModel = (
    data: ILoadsLocationResponse[],
) => {
    const descriptions = [] as ISelectInputModel[];

    data.forEach((desc, index) => {
        descriptions.push({
            key: index?.toString(),
            label: getLabelDescription(desc.description, desc.code),
            value: desc.code,
        });
    });

    return descriptions;
};

export const getUFResultOptions = (states: string[]) => {
    const options = [] as ISelectInputModel[];

    const resultSet = new Set(states);
    resultSet.forEach((item, index) => {
        options.push({
            key: index?.toString(),
            label: item,
            value: item,
        });
    });

    return options;
};

export const getMaterialResultOptions = (data: ILoadMaterialResponse[]) => {
    const selectOptions = [] as ISelectInputModel[];

    const options = new Set(data.map(mat => mat));

    options.forEach(mat => {
        selectOptions.push({
            key: mat.id.toString(),
            label: mat.name,
            value: mat.id,
        });
    });

    return selectOptions;
};
